module.exports = __webpack_public_path__ + "files/edcba2b7ec67641b7acc5fa40c779b91.png";


//////////////////
// WEBPACK FOOTER
// ./images/themes/organization.png
// module id = 932
// module chunks = 76